<template>
    <main class="app-get-step" id="mainContent">
        <div class="app-main-content">
            <div>
                <form>
                    <div class="transaction-total">
                        <button class="add-button" @click="addAnotherTrxn()">Add another transaction</button>
                        <span class="sub-total"><strong>Subtotal ({{$store.state.guestLogin.cartTransactions.cartTransactions.length}} transaction(s)): {{ toCurrencyNum(subTotal) }}</strong></span> 
                    </div>
                    <ul class="transaction-table" v-if="$store.state.guestLogin.renewalCart.length > 0">
                        <li class="transaction-view" v-for="(transactionCart, index) in $store.state.guestLogin.renewalCart" :key="index">
                            <div class="app-reg-notice">
                                <p class="vehicle-reg-info"> <strong>{{ transactionCart.description }} - </strong> 
                                {{ transactionCart.year }} {{ transactionCart.make }}
                                {{ transactionCart.model !='UNKNOWN' ? transactionCart.model : '' }}
                                {{ transactionCart.plateNumber }} / {{ transactionCart.plateType }} </p>
                            </div>
                            <div class="app-reg-notice">
                                <!-- <button class="add-button" type="button" @click="removeTrxn(index)"> Remove from cart </button> -->
                                <CustomButton class="add-button resend-code" @click="removeTrxn(index)"> Remove from cart </CustomButton>
                            </div>
                            <div class="app-reg-notice total-fee" v-if="transactionCart.onlineTransactionFeeCollection !=null">
                                <div class="fees" v-for="(txnFeesCart, i) in transactionCart.onlineTransactionFeeCollection" :key="i">
                                    <div class="fees-list">
                                        <p>{{ txnFeesCart.feeName }} </p>
                                        <p class="fee-amount"> {{ toCurrencyNum(txnFeesCart.feeAmount) }}</p>
                                    </div>
                                </div>
                                <div class="fees">
                                    <div class="fees-list">
                                        <p><strong>Total</strong> </p> <p class="total-charge"><strong> {{ toCurrencyNum(totalAmount(transactionCart)) }}</strong></p>
                                    </div>
                                </div>
                            </div>

                            <div class="app-reg-notice total-fee" v-else>
                                <!-- <div class="fees" v-for="(txnFeesCart, i) in transactionCart.onlineTransactionFeeCollection" :key="i">
                                    <div class="fees-list">
                                        <p>{{ txnFeesCart.feeName }} </p>
                                        <p class="fee-amount"> {{ toCurrencyNum(txnFeesCart.feeAmount) }}</p>
                                    </div>
                                </div> -->
                                <div class="fees">
                                    <div class="fees-list">
                                        <p><strong>Total</strong> </p> <p class="total-charge"><strong> {{ toCurrencyNum(totalAmount(transactionCart)) }}</strong></p>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <BaseButtonGroup>
                        <button class="add-button" @click="addAnotherTrxn()"> Add another transaction </button>
                        <button type="button" class="app-btn-primary" @click="handleRouting(false)"> Proceed to checkout </button>
                    </BaseButtonGroup>
                </form>
            </div>
        </div>
    </main>
</template>
    
<script>
  import appConfig from '@/app.config'
  import BaseButtonGroup from '@/components/ui/BaseButtonGroup'
  import { mapState, mapActions } from 'vuex';
  import * as COMMONS from '../../store/_commons';
  import { toCurrency } from '@/utils/helpers';
  import CustomButton from '../../components/CustomButton.vue';
  
  export default {
    name: 'TransactionCart',
    page: {
      title: `Transaction Cart | ${appConfig.shortName}`,
      meta:
        [{
          name: 'description',
          content: 'You can view the total number of transactions'
        }]
    },
    data() {
      return {
        stepNum: 3,
        screenData: {},
        enableNext: true,
        showError: false,
        }
    },

    components: {
      BaseButtonGroup,
      CustomButton
    },

    computed: {
        ...mapState([
            'LANG',
            'STEPS',
        ]),

        language() {
            return this.LANG;
        },

        subTotal() {
            let total = 0;
            if(this.$store.state.guestLogin.renewalCart.length > 0) {
                this.$store.state.guestLogin.renewalCart.forEach(function (obj)  {
                    if (obj.onlineTransactionFeeCollection != null)
                        {
                            obj.onlineTransactionFeeCollection.forEach(function (txn){
                        total = total + txn.feeAmount;
                        })   
                    }
                });
            }
            return total.toFixed(2);
        },
    },

    created() {
        document.body.setAttribute("tabindex", "1");
        document.body.focus();

        document.body.removeAttribute("tabindex");
    },
    
    methods: {
        ...mapActions({
            getRemoveTransaction: COMMONS.GUEST_REMOVETRANSACTION,
            getServiceFees: COMMONS.GUEST_SERVICEFEES
        }),

        toCurrencyNum(value) {
            return toCurrency(value);
        },

        async handleRouting(isPrev = false) {
            if (isPrev) {
                this.$emit('getStep' , 3)
                this.$store.state.guestLogin.step = 3;
            } 
            else {
                this.$store.state.guestLogin.cartTotal = this.subTotal;
                if(this.subTotal > 0) {
                    await this.getServiceFees(this.subTotal).then(() => {
                    
                    });
                } else {
                    this.$store.state.guestLogin.totalBill = null;
                    this.$store.state.guestLogin.step = 5;
                }
            }
        },

        addAnotherTrxn() {
            this.$router.push({name: 'Profile'});
            this.$store.state.guestLogin.step = 1;
        },

        async removeTrxn(step) {
            try {
                this.$store.commit('setState', { property: 'isLoading', value: true });
                const result = await this.getRemoveTransaction(step);
                console.log('RESULT', result)
                
            } catch (error) {
                console.log(error);
            }
        },

        totalAmount(txnFeesCart) {
            let total = 0;
            if(txnFeesCart.onlineTransactionFeeCollection != null) {
                txnFeesCart.onlineTransactionFeeCollection.forEach (function (obj)  {
                    total = total + obj.feeAmount;   
                });
            }
            return total;
        }
    },

    mounted() {
        window.scroll(0,0);
        this.screenData = this.STEPS[this.stepNum]; 
        document.getElementById("mainContent").focus();
    }
  }
</script>

<style scoped lang="scss">
    .app-alert-error {
        display: block;
        margin-top: 20px;
        margin-bottom: 20px;
        font-size: 18px;
        line-height: 28px;
        padding-left: 10px;
        padding-right: 10px;
    }
    .transaction-total {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 2rem;
        margin-top: 1rem;
        p{
            width: 14%;
        }
        .sub-total {
            text-align: right;
            font-size: 20px;
        }
        .add-button {
            margin-top: 1rem;
        }
    }
    .transaction-table {
        li {
            background-color: white;
            &:nth-child(odd) {
                background-color: #F2F2F2;
            }
        }
        .transaction-view {
            display: flex;
            margin-bottom: 2rem;
            justify-content: space-between;
            .app-reg-notice {
                height: 100%;
                margin-bottom: 0px;
                margin-top: 5px;
                padding: 1rem;
                width: 100%;
                .resend-code{
                    background-color: white;
                    color: var(--ri-blue);
                    &:hover{
                        background-color: var(--ri-lighter-blue);
                        color: var(--ri-darker-blue);
                    }
                }
            }
            .white-space{
                position: relative;
            }
            @media only screen and (max-width: 796px) {
                .app-reg-notice {
                    display: block; 
                    margin-top: 5px;
                }
            }
            @media only screen and (max-width: 956px){
                .app-reg-notice-vehicle{
                    margin-left: 16px; 
                }
            }
            @media only screen and (min-width: 957px) {
                .app-reg-notice-vehicle{
                    max-width: 100%;
                    height: 100%;
                    margin-bottom: 0px;
                    margin-top: 5px;
                    padding: 1rem;
                    position: relative; 
                }
            }
            .fees {
                background-color: #1B243B;
                color: white;
                .fees-list{
                    display: flex;
                    justify-content: space-between;
                    gap: 1rem;
                    p {
                        font-size: 16px;
                        line-height: 23px;
                        padding: 10px;
                    }
                    .total-charge{
                        color: #FFA500;
                        font-weight: 700;
                        width: 100px;
                        text-align: right;
                    }
                    .fee-amount {
                        text-align: right;
                        width: 100px;
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 720px) {
        .transaction-total{
            display: block;
            p {
                display: none;
            }
            span {
                display: block;
                margin-top: 1rem;
                text-align: left !important;
            }
        }
        .transaction-table {
            display: block;
            .transaction-view {
                display: block;

                .white-space{
                    width: unset;
                    background-color: unset;
                    top: 0px;
                    position: relative;
                    margin-left: 0rem;
                }
            }
        }
    }

    @media only screen and (min-width: 721px) and (max-width: 1120px) {
        .transaction-total{
            display: flex;
            p {
                display: none;
            }
            span {
                display: block;
                margin-top: 1rem;
                text-align: left !important;
            }
        }
        .transaction-table {
            display: block;

            .transaction-view {
                display: block;

                .white-space{
                    width: unset;
                    background-color: unset;
                    top: 0px;
                    position: relative;
                    margin-left: 0rem;
                }
            }
            .fees-list {
                gap: 2.5rem !important;
            }
        }
    }
</style>
